<template>
<header id="header" class="header">
  <div class="header__top">
    <div class="header__top__logo">
      <a href="http://www.hankyu-dept.co.jp/honten/">
        <img src="@/assets/images/commons/logo.gif" alt="logo" width="59" height="28">
      </a>
    </div>
    <div class="header__top__honten">
      <a href="http://www.hankyu-dept.co.jp/honten/">
      <img src="@/assets/images/commons/honten.gif" alt="honten" width="70" height="10">
      </a>
    </div>
    <div class="header__top__hum" :class="{'is-active': showMenu}" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <transition>
      <div class="header__top__menu" v-if="showMenu">
        <div class="header__top__menu__logo">
          <div class="header__top__menu__logo__hankyu">
            <img src="@/assets/images/commons/logo.gif" alt="logo" />
          </div>
          <div class="header__top__menu__logo__honten">
            <img src="@/assets/images/commons/honten.gif" alt="logo" />
          </div>
        </div>
        <div class="header__top__menu__ct">
          <p class="header__top__menu__ct__title">MENU</p>
          <ul class="header__top__menu__ct__list">
            <router-link tag="li" :to="{ name: 'home' }" exact>HOME</router-link>
            <router-link tag="li" :to="{ name: 'mycustom' }" exact>MY CUSTOM</router-link>
            <router-link tag="li" :to="{ name: 'howto' }" exact>HOW TO USE</router-link>
            <router-link tag="li" :to="{ name: 'faq' }" exact>FAQ</router-link>
            <li><a href="https://web.hh-online.jp/" target="_blank">HANKYU E-STORES</a></li>
          </ul>
          <!-- <p class="header__top__menu__ct__title">SMART MIRROR MENU</p>
          <ul class="header__top__menu__ct__list">
            <router-link tag="li" :to="{ name: 'marker' }" exact>AR MARKER</router-link>
          </ul> -->
        </div>
      </div>
    </transition>
  </div>
  <div class="header__btm" v-if="this.$route.name !== 'home'">
    <div class="header__btm__ct">
      <router-link to="/" class="header__btm__ct__ttl">
        <div class="header__btm__ct__ttl__sub">My Custom Bag Studio</div>
      </router-link>
    </div>
  </div>
</header>
</template>

<script>
export default {
  data () {
    return {
      showMenu: false
    }
  },
  methods: {
    toggleMenu () {
      this.showMenu = !this.showMenu
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  &__top {
    background: $black;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 6px 10px 6px 10px;
    &__logo {
      width: 59px;
      margin-right: 6px;
    }
    &__honten {
      width: 70px;
    }

    &__menu {
      position: fixed;
      width: 100%;
      height: 100%;
      background:$black;
      left: 0;
      top: 0;
      z-index: 1000;

      &__logo {
        padding: 6px 10px 0 10px;
        display: flex;

        &__hankyu {
          width: 59px;
          margin-right: 6px;
        }

        &__honten {
          width: 70px;
          display: flex;
          align-items: center;
          padding-top: 5px;
        }
      }

      &__ct {
        width: 70%;
        margin: 0 auto 0;
        font-size: 14px;

        &__title {
          text-align: center;
          color: $dark-gray;
          padding: 50px 0 10px;
        }

        &__list {
          border-top: 1px solid rgba($dark-gray, 0.4);

          li {
            padding: 13px 0;
            color: $base-white;
            border-bottom: 1px solid rgba($dark-gray, 0.4);
            cursor: pointer;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              top: 50%;
              right: 0;
              width: 14px;
              height: 14px;
              background: url('../assets/images/commons/menuArrow.svg') top left no-repeat;
              background-size: 14px 14px;
              margin-top: -7px;
            }

            &.router-link-exact-active {
              color: $dark-gray;
            }

            a {
              color: $base-white;
              display: inline-block;
            }
          }
        }
      }
    }

    &__hum {
        position: absolute;
        width: 25px;
        height: 20px;
        top: 10px;
        right: 10px;

        &.is-active {
          z-index: 1001;
          position: fixed;

          span:nth-of-type(1) {
            animation: active-menu-bar01 .75s forwards;
          }
          span:nth-of-type(2) {
            opacity: 0;
          }
          span:nth-of-type(3) {
            animation: active-menu-bar03 .75s forwards;
          }
        }
        span {
          position: absolute;
          left: 0;
          width: 100%;
          height: 1px;
          border-top: 2px solid $base-white;

          &:nth-of-type(1) {
            top: 0;
          }
          &:nth-of-type(2) {
            top: 9px;
            opacity: 1;
          }
          &:nth-of-type(3) {
            bottom: 0;
          }

        }
      }
  }
  &__btm {
    width: 100%;
    background: $base-white;
    border-bottom: 1px solid #5E5E5E;
    display: flex;
    justify-content: center;
    align-items: center;
    &__ct {
      width: 100%;
      text-align: center;
      &__ttl {
        display: block;
        font-size: 14px;
        font-weight: bold;
        padding: 15px;
      }
    }
  }
}

@keyframes menu-bar01 {
  0% {
    transform: translateY(9px) rotate(45deg);
  }
  50% {
    transform: translateY(9px) rotate(0);
  }
  100% {
    transform: translateY(0) rotate(0);
  }
}
@keyframes menu-bar02 {
  0% {
    transform: translateY(-9px) rotate(-45deg);
  }
  50% {
    transform: translateY(-9px) rotate(0);
  }
  100% {
    transform: translateY(0) rotate(0);
  }
}

@keyframes active-menu-bar01 {
  0% {
    transform: translateY(0) rotate(0);
  }
  50% {
    transform: translateY(9px) rotate(0);
  }
  100% {
    transform: translateY(9px) rotate(45deg);
  }
}

@keyframes active-menu-bar03 {
  0% {
    transform: translateY(0) rotate(0);
  }
  50% {
    transform: translateY(-9px) rotate(0);
  }
  100% {
    transform: translateY(-9px) rotate(-45deg);
  }
}

.v-enter-active, .v-leave-active {
  transition: opacity .3s
}

.v-enter, .v-leave-to {
  opacity: 0
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue